import { Fonts } from '@/constants/font';
import { Keys } from '@/constants/key';
import { Tr } from '@/i18n/i18n';
import CU from '@/utils/c-u';
import SpriteUtils from '@/utils/sprite-utils';
import TextUtils from '@/utils/text-utils';
import Container = Phaser.GameObjects.Container;

export class GiftGemsAgitationPanel extends Container {

    constructor(scene: Phaser.Scene, receiverName: string) {
        super(scene);

        this.height = 110;

        const back = SpriteUtils.addImage(this.scene, -300, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, 152 * CU.S);
        this.add(back);

        let byingGemsText = TextUtils.addTextByFamily(scene, Tr('buying.gems.for'),
            0, 40, '#DDDCDC', 14, 'normal', 600, Fonts.BENGALY_NORMAL);

        let playerName = TextUtils.addTextByFamily(scene, receiverName,
            0, 70, '#71ff66', 16, 'normal', 600, Fonts.BENGALY_NORMAL);

        const separator = SpriteUtils.addSprite(this.scene!, 0, this.height, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0.5, 0.5);

        this.add([back, byingGemsText, separator, playerName]);
    }

}